import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

export default function SearchBar({ onSearch }) {
    const router = useNavigate();
const [searchtype, setsearchtype] = useState("");
  const [searchdata, setsearchdata] = useState("");

  const [userselete, setuserselete] = useState(null);

  const loadOptionsPalyer = async (search, loadedOptions, pages) => {
    console.log(loadedOptions);
    console.log(pages);
    const response = await fetch(
      URL.API_BASE_URL +
        `/publicApi/searchareaforproductDis?key=${search}&page=${pages?.page}`
    );
    const responseJSON = await response.json();

    const options = responseJSON?.results?.map((data) => {
      data.value = data?._id;
      data.label = data?.District + ", " + data?.State;

      return data;
    });

    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: pages?.page + 1,
      },
    };
  };

  const hendlesearchProduct = (e) => {
    setsearchdata(e?.target?.value);

    if (e.key === "Enter") {
      e.preventDefault();

      if (searchtype == "listing") {
        if (userselete) {
          router(
            `/listings?search=${e?.target?.value}&location=${userselete?._id}`
          );
        } else {
          router(`/listings?search=${e?.target?.value}`);
        }
      } else if (searchtype == "lostandfound") {
        router(`/products?search=${e?.target?.value}`);
      } else {
        if (userselete) {
          router(
            `/products?search=${e?.target?.value}&location=${userselete?._id}`
          );
        } else {
          router(`/products?search=${e?.target?.value}`);
        }
      }
    }
  };

  const hensletosearch = (e) => {
    e.preventDefault();

    if (searchtype == "listing") {
      // router(`/listings?search=${searchdata}`);
      if (userselete) {
        router(`/listings?search=${searchdata}&location=${userselete?._id}`);
      } else {
        router(`/listings?search=${searchdata}`);
      }
    } else if (searchtype == "lostandfound") {
      router(`/products?search=${searchdata}`);
    } else {
      if (userselete) {
        router(`/products?search=${searchdata}&location=${userselete?._id}`);
      } else {
        router(`/products?search=${searchdata}`);
      }
    }
  };
  return (
    <div className="mx-1 mx-md-2 mx-lg-5 relative">
      <form className="lux-search-box" method="get">
        <input
         
          type="text"
          placeholder="Search ..."
          className="lux-input"
         onChange={(e) => {
                    hendlesearchProduct(e);
                  }}
                  onKeyDown={(e) => {
                    hendlesearchProduct(e);
                  }}
                  id="input-search"
        />

        <button className="lux-btn" type="submit"    onClick={(e) => {
                    hensletosearch(e);
                  }}>
          <i className="fa fa-search"></i>
        </button>

        <span className="lux-border"></span>
        <span className="lux-border"></span>
        <span className="lux-border"></span>
        <span className="lux-border"></span>
      </form>


     
    </div>
  );
}
